import pluralize from 'pluralize';

import { type WorkspaceAgentGuidedVariantSkipCounts } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentGuidedVariantSkipCounts';

type BuildWorkspaceAgentGuidedVariantSkippedLabelParams = WorkspaceAgentGuidedVariantSkipCounts & {
  /** Smart resize and scale or crop keep videos. Other edits still skip them. */
  includesVideos?: boolean;
  toolName: string;
};

export const buildWorkspaceAgentGuidedVariantSkippedLabel = ({
  includesVideos = false,
  skippedFileCount,
  skippedVideoCount,
  toolName,
}: BuildWorkspaceAgentGuidedVariantSkippedLabelParams): string | null => {
  const skippedCount = skippedFileCount + (includesVideos ? 0 : skippedVideoCount);

  if (skippedCount < 1) {
    return null;
  }

  const noun = includesVideos || skippedFileCount > 0 ? 'file' : 'video';
  const appliesTo = includesVideos ? 'images and videos' : 'images';

  return `${skippedCount.toLocaleString()} ${pluralize(noun, skippedCount)} skipped — ${toolName} works on ${appliesTo}.`;
};
